import { KeycloakService } from '@core-services';

export function kcFactory(kcService: KeycloakService) {
  return (): Promise<void> => kcService.init();
}
